import { Select, type SelectProps } from 'antd';
import { useMemo } from 'react';

import { filterOptionByLabel } from '@/utils/selectOption';

import withAutoSelectSingleOption from '../withAutoSelectSingleOption';

import { useGetCrops } from './hooks';

const AutoSelect = withAutoSelectSingleOption(Select);

interface Props extends SelectProps {
  exclude?: string[];
  autoSelectEnabled?: boolean;
}
const SelectCrop = ({ exclude = [], ...selectProps }: Props) => {
  const { options: varietiesOptions, isLoading: isVarietiesLoading } =
    useGetCrops();

  const filteredOptions = useMemo(() => {
    return exclude.length > 0
      ? varietiesOptions.filter(option => !exclude.includes(option.value))
      : undefined;
  }, [exclude, varietiesOptions]);

  return (
    <AutoSelect
      placeholder='Select a crop'
      options={filteredOptions ?? varietiesOptions}
      loading={isVarietiesLoading}
      optionRender={option => option.label}
      filterOption={filterOptionByLabel}
      showSearch
      {...selectProps}
    />
  );
};

export default SelectCrop;
